import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js"

export default class extends Controller {
  static values = {
    newRecord: { type: Boolean, default: false }
  };

  connect() {
    const now = new Date();
    const roundedMinutes = Math.ceil(now.getMinutes() / 5) * 5;
    now.setMinutes(roundedMinutes, 0, 0);
  
    flatpickr(this.element, {
      locale: Russian,
      enableTime: true,
      time_24hr: true,
      minuteIncrement: 5,
      dateFormat: "Y-m-d\\TH:i",
      minDate: "today", 
      inline: true,
      defaultDate: this.newRecordValue ? now.toISOString().slice(0, 16) : null,
    });

    this.element.style.display = "none";
  }
}
